import type {Theme, Components} from "../..";

type TypographyOverrides = Components<Theme>["MuiTypography"];

declare module "@atg-ui/toolkit/components/Typography" {
    interface MoreTypographyPropsVariantOverrides {
        body3: true;
        body4: true;
        display1: true;
        display2: true;
        display3: true;
        display4: true;
        display5: true;
        title1: true;
        title2: true;
        title3: true;
        title4: true;
        title5: true;
        title6: true;
        label1: true;
        label2: true;
        label3: true;
        editorialPreamble: true;
        editorialBody: true;
    }
}

// Update the Typography's variant prop options
declare module "@mui/material/Typography" {
    interface TypographyPropsVariantOverrides {
        // We allow all legacy variants to avoid breaking changes.
        // This is left here to document the legacy variants.
        // h1brand: false;
        // h2brand: false;
        // h3brand: false;
        // h4brand: false;
        // rubrik1: false;
        // rubrik2: false;
        // rubrik3: false;
        // rubrik4: false;
        // caption: false;
        // overline: false;
        // button: false;
        // h1: false;
        // h2: false;
        // h3: false;
        // h4: false;
        // h5: false;
        // h6: false;
        // subtitle1: false;
        // subtitle2: false;
        // subtitle3: false;

        h1brand: true;
        h2brand: true;
        h3brand: true;
        h4brand: true;
        rubrik1: true;
        rubrik2: true;
        rubrik3: true;
        rubrik4: true;
        caption: true;
        overline: true;
        button: true;
        h1: true;
        h2: true;
        h3: true;
        h4: true;
        h5: true;
        h6: true;
        subtitle1: true;
        subtitle2: true;
        subtitle3: true;

        body3: true;
        body4: true;
        display1: true;
        display2: true;
        display3: true;
        display4: true;
        display5: true;
        title1: true;
        title2: true;
        title3: true;
        title4: true;
        title5: true;
        title6: true;
        label1: true;
        label2: true;
        label3: true;
        editorialPreamble: true;
        editorialBody: true;
    }
}

const overrides: TypographyOverrides = {
    defaultProps: {
        variantMapping: {
            body1: "p",
            body2: "p",
            body3: "p",
            body4: "p",
            inherit: "p",
            display1: "h1",
            display2: "h2",
            display3: "h3",
            display4: "h4",
            display5: "h5",
            title1: "h3",
            title2: "h3",
            title3: "h3",
            title4: "h4",
            title5: "h5",
            title6: "h6",
            editorialPreamble: "p",
            editorialBody: "p",
        },
        variant: "body3",
    },
};

export default overrides;
